module.exports = __webpack_public_path__ + "static/brama-zima-8198c1be333be3a37c81a752b6f74327.jpg";